import { useState } from "react";
import { RecordType } from "@lhd/constants";

/**
 * Filter state hook for slicer filters.
 * Note: Filter settings are now persisted on the server (BE) via category_status_worker_settings,
 * so localStorage persistence is no longer needed.
 */
export function useSlicerFilterState<T>(
  _type: RecordType,
  defaultValue: T,
): [T, React.Dispatch<React.SetStateAction<T>>] {
  return useState<T>(defaultValue);
}
